import React from 'react'

function Error() {
  return (
    <div>
      <h1>Error.... page does'nt existe!</h1>
    </div>
  )
}

export default Error
